// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_s6-0";
export var checkoutRateBadgeLink = "_s6-1";